import { DateTime } from '@ksyos/date-time';
import { Koi } from '@ksyos/koi';
import { maxPatientCount, minPatientCount } from '@common/constants';
import type { ISchemaContainer } from './schemaContainer';
import { getMaxReferenceDateTime, getMinReferenceDateTime } from '../utils/calculateReferenceDateTimeForPatientCounts';

export interface IOrganizationPatientCountsValidated {
    count: number;
    id?: string;
    organizationId: string;
    referenceDate: string;
}

const organizationPatientCounts = Koi.object().keys({
    count: Koi.number().integer().min(minPatientCount).max(maxPatientCount).required(),
    id: Koi.string().uuid().optional(),
    organizationId: Koi.string().uuid().required(),
});

const organizationPatientCountsBackend = organizationPatientCounts.concat(
    Koi.object().keys({
        referenceDate: Koi.koi().date().custom(isValidReferenceDate).required(),
    })
);

const organizationPatientCountsFrontend = organizationPatientCounts.concat(
    Koi.object().keys({
        referenceDate: Koi.koi().date().required(),
    })
);

export const organizationPatientCountsSchema: ISchemaContainer<IOrganizationPatientCountsValidated[]> = {
    schema: Koi.array().items(organizationPatientCountsBackend).options({ convert: false, presence: 'required' }),
};

export const organizationPatientCountsFrontendSchema: ISchemaContainer<IOrganizationPatientCountsValidated[]> = {
    schema: Koi.array().items(organizationPatientCountsFrontend).options({ convert: false, presence: 'required' }),
};

export function isValidReferenceDate(referenceDate: string) {
    const referenceDateTime = DateTime.from(referenceDate);
    const minReferenceDateTime = getMinReferenceDateTime();
    const maxReferenceDateTime = getMaxReferenceDateTime();

    const isValid =
        isFirstDayOfQuarter(referenceDate) &&
        referenceDateTime.isBetween(minReferenceDateTime, maxReferenceDateTime, undefined, '[]');

    if (!isValid) {
        throw new Error('Invalid date');
    }

    return referenceDate;
}

function isFirstDayOfQuarter(date: string): boolean {
    const dateTime = DateTime.from(date);

    return dateTime.month() % 3 === 0 && dateTime.date() === 1;
}
